import { render, staticRenderFns } from "./NotificationTemplateList.vue?vue&type=template&id=3e63bb1a"
import script from "./NotificationTemplateList.vue?vue&type=script&lang=js"
export * from "./NotificationTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports